import React from 'react'
import clsx from 'clsx';
import styles from './TopMenu.module.scss'
import { ReactComponent as IconNotification } from 'images/new-icons/notification.svg';
import { ReactComponent as IconSearch } from 'images/new-icons/search.svg';
import { useNavigate } from 'react-router-dom';



const TopMenuWithSearch = () => {
    const navigate = useNavigate()
    return (
        <div className={clsx(styles.container)}>
            <IconNotification onClick={() => navigate('/user-notifications')} />
            {/* <IconSearch /> */}
        </div>
    )
}

export default TopMenuWithSearch